import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

export const init = function (app: any, router: any) {
  Sentry.init({
    app,
    dsn: "https://0bc835ab020642ad979b132035c924ae@o483560.ingest.sentry.io/6203799",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "prensa.filmin.es", /^\//],
      }),
    ],
    logErrors: true,
    tracesSampleRate: 0,
  });
};
